define('responsive-gameday/views/distributors/viewDistributors/PlayByPlayDistributor',['require','exports','module','GameDayCore','jquery','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/baseball/GameStates'],function(require,exports,module) {
    var GDC = require("GameDayCore"),
        $ = require("jquery"),
        ViewDistributorClass = require("./ViewDistributorBase"),
        UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../events/DistributionEvents"),
        exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        GameStates = require("GameDayCore/GDModel/enums/baseball/GameStates");

    var Superclass;

    function PlayByPlayDistributor(evt) {
        this.eventType = evt;
        Superclass.constructor.call(this,evt);

        MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_PLAYBYPLAY_DATA, this.handleUpdateRequest);
    }

    ViewDistributorClass.spawn(PlayByPlayDistributor).define({
        prepDataForView: function() {
            this.dataPack = {
                linescore : this.game.liveData.linescore,
                teams     : this.game.gameData.teams
            };
            this.dispatchUpdates();
        }
    });

    Superclass = PlayByPlayDistributor.superclass;

    return PlayByPlayDistributor;
});

